export default __webpack_public_path__ + "static/blob7-3524fcaf3353479577111a5a85aaa822.svg";